module.exports = __webpack_public_path__ + "static/a-xx-120-art-0e88894dd50d5e5281a863042cad40bf.jpg";